<template>
  <video ref="videoRef" controls v-bind="$attrs" @click.stop="handle"/>
</template>

<script>
export default {
  name: 'video-play',
  methods: {
    play() {
      this.$refs.videoRef.play()
    },
    stop() {
      if (!this.$refs.videoRef) return
      this.$refs.videoRef.pause()
      this.$refs.videoRef.currentTime = 0
    },
    handle() {
    }
  }
}
</script>

<style scoped lang="scss">
</style>
